<template>
  <div class="banner">
    <div class="pc-banner" v-if="banner1">
      <img :src="banner1.img" alt="">
      <div class="content">
        <div class="inner" v-if="lan === 0">
          <div class="auto_1280 title">{{banner1.title1}}</div>
          <div class="auto_1280 txt">{{banner1.title2}}</div>
        </div>
        <div class="inner en" v-if="lan === 1">
          <div class="auto_1280 title">{{banner1.enTitle1}}</div>
          <div class="auto_1280 txt">{{banner1.enTitle2}}</div>
        </div>
      </div>
    </div>
    <div class="wap-banner" v-if="banner1">
      <img :src="banner1.img2" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'banner',
  props: {
    banner1: Object
  },
  data () {
    return {
      lan: this.$store.state.isEn
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
    }
  }
}
</script>
<style scoped>
.banner{min-height: calc(100vw * .3); background-color: rgba(228,0,127,0.2);}
.banner .pc-banner{position: relative; min-height: calc(100vw * .3)}
.banner .wap-banner{display: none;}
.banner .pc-banner img,
.banner .wap-banner img{width: 100%;}
.banner .content{position: absolute; top: 0; left: 0; width: 100%; height: 100%;}
.banner .content .inner{position: absolute; left: 0; top: 50%; width: 100%; transform: translateY(-50%);}
.banner .title{font-size: 48px; color: #fff;}
.banner .txt{font-size: 18px; color: #fff; font-weight: lighter; padding-top: 1%; letter-spacing: 4px;}
.banner .en .txt{letter-spacing: 2px;}
@media(max-width: 1024px){
  .banner{min-height: calc(100vw * .43);}
  .banner .pc-banner{display: none;}
  .banner .wap-banner{display: block;}
}
</style>
